import React from 'react'
import PropTypes from 'prop-types'
import styles from './style/outlet_product_card_style.module.scss'
import Typography from '../../foundations/typography/Typography'
import Foundation from '../../foundations/Foundation'
import Translation from '../../../global/Translation'
import Button from '../../basics/button/Button'
import DisplayOutletIndicator from '../../../catalog/rectangleResult/displays/DisplayOutletIndicator'
import DisplayDiscontinued from '../../../catalog/rectangleResult/displays/DisplayDiscontinued'
import { REPO_STONES_FAMILIES } from '../../../natural-stone/NaturalStoneHelper'
import { injectIntl } from 'react-intl'
import PnDisplayPrice from '../../../natural-stone/display-prices/PnDisplayPrice'
import LocalizedLink from '../../../global/LocalizedLink'
import { connect } from 'react-redux'
import { getUserPriceList } from '../../../../store/login/reducers'
import { canViewPricesPhase3, discountsByProductId } from '../../../../store/products/reducers'
import { getPromotions } from '../../../catalog/rectangleResult/displays/DisplayPriceBase'
import { getLanguageDir } from '../../../../store/ui/reducers'

const OutletProductCard = ({ className = '', style = {}, product, click, ...props }) => {

    const promotions = props.canViewPricesPhase3 && getPromotions(props.productDiscounts, product.outletQuality)
    const dealType = promotions && promotions.length > 0 && promotions[0].dealType
    const family = typeof product.family === 'string' ? product.family : ''
    const familyTranslationId = REPO_STONES_FAMILIES[family.toUpperCase()]
    const familyLabel = familyTranslationId ? props.intl.formatMessage({ id: familyTranslationId }) : family

    return (
        <Foundation neutral-900>
            <div className={`${styles['outlet-product-card']} ${className}`}>
                <div className={styles['outlet-product-card-image-container']}>
                    <img
                        src={product.imgFull}
                        alt={`${product.displayName} image`}
                        className={styles['outlet-product-card-image']}
                        width='100%'
                    />

                    <div className={styles['outlet-product-card-indicators']}>
                        <DisplayOutletIndicator
                            style={{width:'fit-content'}}
                            outletQuality={product.outletQuality}
                        />
                        <DisplayDiscontinued
                            style={{width:'fit-content'}}
                            discontinued={product.discontinued}
                        />
                    </div>

                    {dealType &&
                        <div className={styles['outlet-product-card-discounts']}>
                            <div className={styles['outlet-product-card-discount-tab']}>
                                <Typography typeface={'body-xs-bold'} white>
                                    {dealType === 'B' ? `-${promotions[0].value}%` : props.intl.formatMessage({ id: 'new_price' })}
                                </Typography>
                            </div>
                        </div>
                    }

                </div>

                <div className={styles['outlet-product-card-content']}>
                    <div className={styles['outlet-product-card-title']}>
                        <Typography block typeface="title-xs-light" neutral-600>
                            {`${familyLabel} - ${product.brand.toLowerCase()}®`}
                        </Typography>
                        <Typography block typeface="title-l-regular">
                            {product.displayName.toLowerCase()}
                        </Typography>
                    </div>

                    <div className={styles['outlet-product-card-desc']}>
                        <Typography block typeface="title-s-light">
                            {`${product.subtypeName} / ${props.intl.formatMessage({id:product.finish})} / ${product.thickness}`}
                        </Typography>
                    </div>

                    <div className={styles['outlet-product-card-price']}>
                        <PnDisplayPrice product={product} outlet={true} />
                    </div>

                    {
                        product.stock_outlet > 0 ? (
                            <LocalizedLink
                                routeId="ROUTE_LOT_PRODUCT_IMAGE_VIEWER"
                                params={{
                                    parentUrl: window.location.href,
                                    productId: product.productId,
                                    center: props.centerId,
                                    outlet: 'outlet'
                                }}
                            // gtmLabel="ec_lupa"
                            >
                                <Button style-black
                                        size-m
                                        onClick={() => click(product, props.list, props.index )}
                                        img={props.languageDir === 'rtl' ? "arrow_short_inverse" : "arrow_short"}
                                        hImg={props.languageDir === 'rtl' ? "arrow_large_inverse" : "arrow_large"}
                                        className={styles['outlet-product-card-button']}
                                >
                                    <Translation id='choose_lot' defaultMessage='Choose lot' />
                                </Button>
                            </LocalizedLink>
                        ) : (
                        <LocalizedLink
                            routeId="ROUTE_PRODUCT_DETAIL"
                            params={{
                                parentUrl: window.location.href,
                                id: product.productId,
                                center: props.centerId,
                                outlet: 'outlet'
                            }}
                            // gtmLabel="ec_lupa"
                        >
                            <Button style-black
                                    size-m
                                    onClick={() => click(product, props.list, props.index )}
                                    img={props.languageDir === 'rtl' ? "arrow_short_inverse" : "arrow_short"}
                                    hImg={props.languageDir === 'rtl' ? "arrow_large_inverse" : "arrow_large"}
                                    className={styles['outlet-product-card-button']}
                            >
                                <Translation id="view_detail" defaultMessage="View detail" />
                            </Button>
                        </LocalizedLink>
                    )}
                </div>
            </div>
        </Foundation>
    )
};

const mapStateToProps = (state, ownProps) => {
    let productId = ownProps && ownProps.product && ownProps.product.productId
    return {
        productDiscounts: discountsByProductId(state, productId, true),
        canViewPricesPhase3: canViewPricesPhase3(state),
        languageDir: getLanguageDir(state)
    }
}

const mapDispatchToProps = dispatch => {
    return {
        click: (product, list, index) => dispatch({ type: 'PRODUCT_CLICK', product, list, index})
    }
}

OutletProductCard.propTypes = {
    src: PropTypes.string.isRequired,
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(OutletProductCard));
